import { APIResponse, returnAxios } from 'app/shared/util/class-utils';
import axios, { AxiosResponse } from 'axios';
import TagManager from 'react-gtm-module';
import { v4 as uuidv4 } from 'uuid';
export interface IGtmApi {
  updateContainerId(): Promise<APIResponse<any>>;
  initGtm(gtmContainerId): Promise<any>;
  gtmEvent(gtmId: string, eventCategory: string, eventAction: string, subscriptionNumber: string, eventValue: string): Promise<any>;
}

const GA_LOCAL_STORAGE_KEY = 'ga:clientId';

export class GtmApi implements IGtmApi {
  async updateContainerId(): Promise<APIResponse<any>> {
    return returnAxios(axios.get('gtm/container-id'));
  }

  async initGtm(gtmContainerId): Promise<any> {
    return new Promise((resolve, reject) => {
      this.changeClientId();

      const tagManagerArgs = {
        gtmId: gtmContainerId
      };

      TagManager.initialize(tagManagerArgs);

      return resolve(true);
    });
  }

  refreshClientId() {
    localStorage.removeItem(GA_LOCAL_STORAGE_KEY);
    return this.changeClientId();
  }

  changeClientId() {
    (window as any).dataLayer = (window as any).dataLayer ? (window as any).dataLayer : [];

    let CLIENT_ID = uuidv4();
    if (window.localStorage) {
      if (localStorage.getItem(GA_LOCAL_STORAGE_KEY)) {
        CLIENT_ID = localStorage.getItem(GA_LOCAL_STORAGE_KEY);
      } else {
        window.localStorage.setItem(GA_LOCAL_STORAGE_KEY, CLIENT_ID);
      }
    }

    (window as any).dataLayer.push({
      clientId: CLIENT_ID
    } as any);
  }

  async gtmEvent(gtmId: string, eventCategory: string, eventAction: string, subscriptionNumber: string, eventValue: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const gtmEvent: any = {
        event: 'santianoDidomiEvent',
        eventCategory,
        eventAction,
        eventLabel: localStorage.getItem(GA_LOCAL_STORAGE_KEY) ? localStorage.getItem(GA_LOCAL_STORAGE_KEY) : 'Numero ClientID manquant',
        eventValue
      };
      if ((window as any).dataLayer) (window as any).dataLayer.push(gtmEvent);
      return resolve(true);
    });
  }
}
